import { baseReducerState, BaseReducerState } from "Store/Shared/Store/PropTypes";

export type FileId = string;

export interface FileState {
    _isFetching: boolean,
    _isPatching: boolean,
    _isUploading: boolean,
    _forceFetch: boolean,
    ids: FileId[],
    entities: {},
    byEntityId: {}
}

export const initialFileState: FileState = {
    _isFetching: false,
    _isPatching: false,
    _isUploading: false,
    _forceFetch: true,
    ids: [],
    entities: {},
    byEntityId: {}
}